export default "__VITE_ASSET__639b73b5__"